import { GridColDef } from '@mui/x-data-grid-pro';
import { TFunction } from 'i18next';

export const showColumns = (t: TFunction) =>
  [
    {
      field: 'accountFormat',
      headerName: t('accountName'),
      flex: 1
    },
    {
      field: 'host',
      headerName: t('host'),
      flex: 1
    },
    {
      field: 'apiPrefix',
      headerName: t('apiPrefix'),
      flex: 1
    },
    {
      field: 'user',
      headerName: t('username'),
      flex: 1
    },
    {
      field: 'apikey',
      headerName: t('apiKey'),
      flex: 1,
      valueGetter: () => {
        return '*************';
      }
    }
  ] as GridColDef[];
